import { Box, InputAdornment, Tooltip } from '@mui/material';
import { MdSync } from 'react-icons/md';

export function UnsavedIcon() {
  return (
    <Tooltip title="Updates when you save" placement="top" arrow>
      <Box
        component="span"
        role="img"
        aria-label="Unsaved"
        sx={(theme) => ({ display: 'flex', color: theme.palette.warning.main })}
      >
        <MdSync size={20} />
      </Box>
    </Tooltip>
  );
}

export function UnsavedAdornment() {
  return (
    <InputAdornment position="end">
      <UnsavedIcon />
    </InputAdornment>
  );
}
